var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","d":"M18.667 15.604c4.12.81 7 2.66 7 4.813 0 2.9-5.223 5.25-11.666 5.25-6.444 0-11.667-2.35-11.667-5.25 0-2.153 2.88-4.003 7-4.814m4.667 4.23V10.5m0 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"}));
}

Location.defaultProps = {"width":"28","height":"28","fill":"none"};

module.exports = Location;

Location.default = Location;
